import BaseModelService from '../../base/base_model_service';
import _ from '../../utils/underscore';

class GameConversionServiceModel extends BaseModelService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GameConversionServiceModel';

    conversionFlags = [300,300,300];
    activeFlag = -1;


    /**
     *
     * @param params
     */
    init(params) {
        if(params)
            this._setConversionFlags(params.flags);
    }


    /**
     * Setter to flags array. Configuration holds 3 timers
     *
     * @param timers
     * @returns {GameConversionServiceModel}
     * @private
     */
    _setConversionFlags(timers) {
        let flagList = [];
        if (_.isString(timers)) {
            flagList = _.safeJSON(timers, this.conversionFlags);
        } else if(_.isArray(timers)) {
            flagList = timers;
        }

        this.conversionFlags = flagList;
        return this;
    }


    /**
     * Update currently active flag and return timer value
     *
     * @param flagIndex
     * @returns {number}
     */
    setActiveFlag(flagIndex) {
        if (!_.isNumber(flagIndex) || flagIndex > this.conversionFlags.length -1 || flagIndex < 0) {
            console.log('Incorrect flag index. Update activated timer failed');
            return;
        }
        this.activeFlag = flagIndex;

        return this.conversionFlags[flagIndex];
    }


    /**
     * Reset activated flag
     *
     * @returns {GameConversionServiceModel}
     */
    resetFlag() {
        this.activeFlag = -1;

        return this;
    }


    /**
     * Get active flag
     *
     * @returns {number}
     */
    getActiveFlag() {
        return this.activeFlag;
    }

}

export default GameConversionServiceModel;